import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {TokenStoreService} from '@core/services/token/token-store.service';

export const adminAuthGuard: CanActivateFn = () => {
  const tokenStore = inject(TokenStoreService);
  const router = inject(Router);

  return tokenStore.isAdminLoggedIn() || router.createUrlTree(['/admin/login']);
};
